// ──────────────────────────────────────────────────────
// Phase 9S — small pure helper that decides whether a product card
// should show the "غير متوفر حالياً" availability badge.
//
// The decision is centralized here (instead of duplicated across
// HeroCard / BudgetCard / ProductCardLegacy) so a single change keeps
// the three surfaces consistent.
//
// Pure: no React, no DOM, no I/O.
// ──────────────────────────────────────────────────────
import type { ProductSuggestion } from '@/lib/types';

/** True when the product should be flagged as currently unavailable on
 *  the card. Either the structured `availabilityStatus` or the boolean
 *  `inStock` fallback can drive it; both kept optional so legacy
 *  payloads (no availability fields) silently render as "available". */
export function isProductOutOfStock(product: Pick<ProductSuggestion, 'availabilityStatus' | 'inStock'>): boolean {
    if (product.availabilityStatus === 'out_of_stock') return true;
    if (product.inStock === false) return true;
    return false;
}

/** Localized Arabic label rendered on the badge. Centralized so a
 *  copy change lands in one place. */
export const OUT_OF_STOCK_LABEL_AR = 'غير متوفر حالياً';
